import { DetailedHTMLProps, FC, HTMLAttributes, ReactNode, useEffect, useRef, useState } from 'react';
import Tooltip from './Tooltip';
import { twMerge } from 'tailwind-merge';

interface OverflowTooltipProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    children: ReactNode;
    contentClassName?: string;
    interactive?: boolean;
}

const OverflowTooltip: FC<OverflowTooltipProps> = (props) => {
    const { children, className, contentClassName, interactive = true, ...rest } = props;

    const containerRef = useRef(null);
    const [isOverflowed, setIsOverflowed] = useState(false);

    useEffect(() => {
        const container = containerRef.current;

        if (!container) return;

        setIsOverflowed(container.scrollWidth > container.clientWidth);
    }, [children]);

    return (
        <Tooltip
            content={isOverflowed ? children : null}
            contentClassName={twMerge('max-w-lg z-[100]', contentClassName)}
            placement="bottom-start"
            className="overflow-hidden"
            interactive={interactive}
        >
            <div {...rest} ref={containerRef} className={twMerge('truncate', className)}>
                {children}
            </div>
        </Tooltip>
    );
};

export default OverflowTooltip;
